import { AggregationModel, AggregationResponse, ApiResultFailed, AuditModel, GrouppedQueryModel, HttpResponse, Operation, RequestParams } from '@/libs/Api';
import ApiService from '@/libs/core/api-service';
import { CrudDataQuery, CrudService } from '@/libs/core/+state/models/crud-service';
import { CrudEnumerableResponse, CrudResponse } from '../core/+state/models/crud-response';

export class AuditsDataService implements CrudService<AuditModel, AuditModel> {
    getAll(query: CrudDataQuery<AuditModel>): Promise<CrudEnumerableResponse<AuditModel>> {
        return ApiService.api.getAuditBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<AuditModel>): Promise<CrudEnumerableResponse<AuditModel>> {
        return ApiService.api.getAuditBasicBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<AuditModel>> {
        return ApiService.api.getAuditById(id, params);
    }

    create(item: AuditModel, params?: RequestParams): Promise<CrudResponse<AuditModel>> {
        return ApiService.api.insertAudit(item, params);
    }

    update(item: AuditModel, params?: RequestParams): Promise<AuditModel> {
        return ApiService.api.updateAudit(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<AuditModel> {
        return ApiService.api.patchAudit(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<AuditModel>): Promise<CrudEnumerableResponse<AuditModel>> {
        return ApiService.api.deleteAudits(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationAudit(query, params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<AuditModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        return ApiService.api.exportAuditBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    clone(item: AuditModel, params?: RequestParams): Promise<CrudResponse<AuditModel>> {
        return ApiService.api.cloneAudit(item, params);
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getAuditGroupped(query, params);
    }
}
